var map = {
	"./655aaa942f2a3.png": 4640,
	"./aboutuspict1.jpeg": 4333,
	"./aboutuspict11.jpeg": 348,
	"./award1.jpg": 7012,
	"./award2.jpeg": 7068,
	"./award3.jpeg": 7651,
	"./award4.jpeg": 8002,
	"./award5.jpeg": 8329,
	"./award6.jpg": 3391,
	"./award7.jpg": 7010,
	"./award8.jpeg": 3630,
	"./belut.jpeg": 5981,
	"./crackers.png": 9262,
	"./css/Home.module.css": 1837,
	"./css/home/home.css": 4172,
	"./domestik1.jpeg": 3612,
	"./domestik2.jpeg": 141,
	"./domestik3.jpeg": 1478,
	"./domestik4.jpeg": 7615,
	"./domestik5.jpeg": 3016,
	"./domestik6.jpeg": 1161,
	"./domestik7.jpeg": 306,
	"./domestik8.jpeg": 3579,
	"./homepict1.png": 2248,
	"./homepict2.png": 4227,
	"./homepict3.png": 4394,
	"./homepict4.png": 6453,
	"./homepict5.png": 4828,
	"./katalog_naktaraso.png": 9144,
	"./legalitas1.png": 1549,
	"./legalitas2.png": 342,
	"./lele.jpeg": 6477,
	"./logo.png": 3153,
	"./logo2.png": 4343,
	"./mitra1.png": 2010,
	"./mitra2.png": 993,
	"./mitra3.png": 2728,
	"./mitra4.png": 7895,
	"./mitra5.png": 4878,
	"./mitra6.png": 6677,
	"./mitra7.png": 1231,
	"./mitra8.png": 7211,
	"./mitra9.png": 6082,
	"./pasta.png": 9235,
	"./rte_nak_taraso.png": 1531,
	"./rumah.jpeg": 2522,
	"./sapi.jpeg": 8706,
	"./satset.png": 7656,
	"./selangor1.jpeg": 2723,
	"./selangor2.jpeg": 4710,
	"./sertif1.png": 4302,
	"./sertif2.png": 1653,
	"./shopee.png": 5334,
	"./singapore1.jpg": 7663,
	"./singapore2.jpeg": 2569,
	"./singapore3.jpeg": 370,
	"./singapore4.jpeg": 2451,
	"./telur.jpg": 6524,
	"./tokopedia.png": 6763,
	"./tuna.jpeg": 3315,
	"./whatsapp.png": 650,
	"./youtube": 7710,
	"./youtube.json": 7710,
	"./youtube.png": 4149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;